<template>
    <!-- 在线展览 -->
    <div class="exhibition_warp">
         <BasePage
            topImg="https://www.ynggwhy.cn/file/group1/M00/00/26/rNYBQF8w4q-EX4_8AAAAAGclYFY444.png"
            tabNum="3"
            :showSort="false"
            ref="basePage"
        >
            <template scope="{item}">
                <div class="list_item" :key="item.id" @click="toDetail(item)">
                    <div class="item_img_box">
                        <el-image class="item_img" :src="item.imageUrl">
                            <div slot="placeholder" class="image_slot">
                                <i class="el-icon-loading"></i>
                            </div>
                        </el-image>
                        <div class="item_status">图片</div>
                    </div>
                    <div class="item_info">
                        <div class="item_info_title ellipsis">{{item.title}}</div>
                        <div class="bot">
                            <span style="margin-right:auto;">浏览 0</span>
                            <svg-icon icon-class="comment" class-name="card-panel-icon" />
                            <span style="margin-right:7px">{{1}}</span>
                            <svg-icon icon-class="thumb" class-name="card-panel-icon" />
                            <span>{{1}}</span>
                        </div>
                        <div class="item_footer">
                            <img class="item_footer_icon" src="https://www.ynggwhy.cn/file/hbY3dGDs5jDBxn6RTX/2020-06-01/source/9b388f9766b64b4cbf7dabe8c27852ac.png" >
                            <span style="margin-right:auto">云南省文化馆</span>
                        </div>
                    </div>
                </div>
            </template>
        </BasePage>
    </div>
</template>

<script>
import BasePage from '@c/BasePage'


export default {
    name: 'exhibition',
    components: {
        BasePage
    },
    data() {
        return {

        }
    },
    beforeRouteUpdate(to, from, next) {
        this.$refs.basePage.loadImage(to.query.id)
        next()
    },
    methods: {
        toDetail(item) {
            this.$router.push(`/exhibition/detail/${item.id}`)
        }
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">
@import "@/styles/com_item.scss";

.exhibition_warp {
    background: #f8f8f8;
    .item_img_box {
        height: 181px;
    }
    .list_item {
        height: auto;
    }
    .item_img {
        width: 100%;
        height: 181px;
        object-fit: cover;
    }
    .image_slot {
        text-align: center;
        padding-top: 50px;
        font-size: 30px;
    }
    .item_status {
        position: absolute;
        top: 18px;
        left: 18px;
        width: 59px;
        height: 23px;
        line-height: 23px;
        border-radius: 23px 23px 23px 0;
        font-weight: 400;
        text-align: center;
        color: #fff;
        font-size: 14px;
        background: #ff9c00;
    }
}
</style>